class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();

    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

function initCouponElement(el) {
  if (el._v2init) return;
  el._v2init = true;

  const input = el.querySelector('input[name="discount"]');
  const button = el.querySelector('[data-update-coupon]');
  if (!input || !button) return;

  if (localStorage.getItem('storedDiscount')) {
    input.value = localStorage.getItem('storedDiscount');
  }

  const applyCoupon = () => {
    const code = input.value.trim();
    if (!code) return;

    localStorage.setItem('storedDiscount', code);

    const popup = document.querySelector('.popup-toolDown.show');
    if (popup) popup.classList.remove('show');
    const previewCart = document.querySelector('.previewCart');
    if (previewCart) previewCart.classList.remove('active-tool');

    fetch(`/discount/${encodeURIComponent(code)}`)
      .then((response) => {
        if (!response.ok) {
          console.warn('[CouponCode] Falha ao aplicar cupom:', code);
          return;
        }
        if (window.Shopify && typeof Shopify.getCart === 'function'
            && window.halo && typeof halo.updateSidebarCart === 'function') {
          Shopify.getCart((cart) => halo.updateSidebarCart(cart));
        }
      })
      .catch((err) => console.error('[CouponCode] Erro de rede:', err));
  };

  button.addEventListener('click', applyCoupon);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      applyCoupon();
    }
  });
}

class CouponCode extends HTMLElement {
  connectedCallback() {
    initCouponElement(this);
  }
}
customElements.define('coupon-code', CouponCode);

// Re-inicializa elementos restaurados do bfcache (iOS Safari / Chrome mobile)
window.addEventListener('pageshow', () => {
  document.querySelectorAll('coupon-code').forEach(initCouponElement);
});
